import {connect} from 'react-redux'
import LayoutLoggedIn from 'components/Layout/LayoutLoggedIn'
import LayoutNotLoggedIn from 'components/Layout/LayoutNotLoggedIn'
import {isFullSiteMode, isMobileDevice} from 'utils/fullSite'

class Layout extends React.Component {
  render () {
    let {data, history, dispatch, location, routes, children} = this.props
    let {moka} = data
    let {loggedIn} = moka

    // TODO optimize this to only 1 element
    return (
      <div className={'full-height'}>
        {
          loggedIn
            ? <div className={'full-height'}>
              {!isMobileDevice() &&
                <LayoutLoggedIn
                  data={data}
                  history={history}
                  dispatch={dispatch}
                  location={location}
                  routes={routes}
                  children={children}
                />
              }

              { isMobileDevice() && !isFullSiteMode() &&
                <LayoutNotLoggedIn
                  data={data}
                  history={history}
                  dispatch={dispatch}
                  location={location}
                  routes={routes}
                  children={children}
                />
              }

              { isMobileDevice() && isFullSiteMode() &&
                <LayoutLoggedIn
                  data={data}
                  history={history}
                  dispatch={dispatch}
                  location={location}
                  routes={routes}
                  children={children}
                />
              }
            </div>
            : <LayoutNotLoggedIn
              data={data}
              history={history}
              dispatch={dispatch}
              location={location}
              routes={routes}
              children={children}
              />
        }
      </div>
    )
  }
  _getClassByPath () {
    let {location} = this.props
    let classbyPath = location.pathname.split('/')
    if (location.pathname.startsWith('/feedback')) {
      return 'feedback'
    }
    if (classbyPath[1] === 'reset-password') {
      return 'reset-password'
    }
    return classbyPath[classbyPath.length - 1]
  }
}

Layout.propTypes = {
  data: React.PropTypes.object,
  history: React.PropTypes.object,
  location: React.PropTypes.object,
  children: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  outlets: React.PropTypes.array,
  loggedIn: React.PropTypes.bool
}

function select (state) {
  return {
    data: {
      moka: state.moka,
      subscriptionExpired: state.subscriptionExpired,
      notification: state.notification
    }
  }
}

export default connect(select)(Layout)



// WEBPACK FOOTER //
// ./app/components/Layout/Layout.js